import { useTranslation } from 'react-i18next';

import Typography from '@material-ui/core/Typography';

import ScreenContainer from 'components/containers/ScreenContainer';

function Inbox() {
	const { t } = useTranslation();
	return (
		<ScreenContainer title={t('general:inbox')}>
			<Typography>{t('general:inbox')}</Typography>
		</ScreenContainer>
	);
}

export default Inbox;
